var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 130,
    viewBox: "0 0 100 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.8644 12.8118C58.2324 8.52095 54.9637 4.72044 52.4213 1.53291C52.3002 1.28772 52.0581 1.16512 51.937 1.04253C50.6053 -0.0608477 48.6683 0.184347 47.5787 1.53291C45.0363 4.72044 41.7676 8.52095 38.1356 12.8118C22.155 31.5692 0 57.5598 0 79.2595C0 93.2355 5.56901 105.863 14.6489 115.058C23.7288 124.13 36.1986 129.892 50 129.892C63.8015 129.892 76.2712 124.253 85.3511 115.058C94.431 105.863 100 93.2355 100 79.2595C100 57.5598 77.845 31.5692 61.8644 12.8118ZM80.9927 110.522C73.0024 118.613 62.1065 123.64 50 123.64C37.8935 123.64 26.9976 118.613 19.0073 110.644C11.138 102.676 6.17433 91.5192 6.17433 79.2595C6.17433 59.8891 27.4818 34.8793 42.8571 16.8576C45.3995 13.7926 47.8208 10.9729 50 8.27576C52.1792 10.9729 54.6005 13.7926 57.1429 16.735C72.5182 34.7567 93.8257 59.6439 93.8257 79.1369C93.8257 91.3966 88.862 102.43 80.9927 110.522Z",
    fill: "#003f2d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2423 107.58C42.7362 107.58 35.9566 104.515 31.1139 99.6109C26.2713 94.7071 23.2447 87.8417 23.2447 80.2407C23.2447 78.5243 21.913 77.1758 20.218 77.1758C18.5231 77.1758 17.1914 78.5243 17.1914 80.2407C17.1914 89.558 20.9444 97.8946 26.8766 104.024C32.6878 109.909 41.0413 113.709 50.2423 113.709C51.9372 113.709 53.2689 112.361 53.2689 110.645C53.2689 108.928 51.9372 107.58 50.2423 107.58Z",
    fill: "#003f2d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFresh);
export default __webpack_public_path__ + "static/media/fresh.f11ec50113254e45da77a38ff17ac7bd.svg";
export { ForwardRef as ReactComponent };